// const footerNewsLetterBtn = document.querySelector('.footer [type="submit"]');
// const homeFeaturedCollectionBTN = document.querySelector('section#shopify-section-template--16836993188006__featured-collections .button');
// const homeBlogBTN =  document.querySelector('section#shopify-section-template--16836993188006__blog-posts .button');

// homeFeaturedCollectionBTN.style.cssText = " box-shadow:rgba(142, 142, 142, 0.3) 2px 2px 5px"
// homeBlogBTN.classList.add('button--outline');
// footerNewsLetterBtn.classList.add('button--outline');
// footerNewsLetterBtn.style.cssText = "padding: 10px;"

document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
});



document.addEventListener("DOMContentLoaded", function() {
  var observer = new MutationObserver(function(mutations, obs) {
    var moreOptionsLink = document.getElementById("more-payment-options-link");
    if (moreOptionsLink && moreOptionsLink.textContent !== "Secure SSL Encrypted Checkout") {
      moreOptionsLink.textContent = "Secure SSL Encrypted Checkout";
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener("click", function (e) {
  const trigger = e.target.closest(
    ".loox-review-text, .loox-rating, .loox-rating-wrapper, a[href='#looxReviews']"
  );

  if (!trigger) return;

  const target = document.getElementById("looxReviews");
  if (!target) return;

  e.preventDefault();

  function getHeaderOffset() {
    const header =
      document.querySelector("sticky-header") ||
      document.querySelector(".shopify-section-header-sticky") ||
      document.querySelector(".section-header") ||
      document.querySelector("header");

    let headerHeight = header ? header.getBoundingClientRect().height : 0;

    // Shopify admin/design mode bottom/top bar issue
    const adminBar = document.querySelector("#preview-bar-iframe");
    const adminHeight = adminBar ? adminBar.getBoundingClientRect().height : 0;

    return headerHeight + adminHeight + 30;
  }

  function scrollToLoox(behavior = "smooth") {
    const offset = getHeaderOffset();

    const y =
      target.getBoundingClientRect().top +
      window.scrollY -
      offset;

    window.scrollTo({
      top: y,
      behavior: behavior
    });
  }

  // First instant scroll fixes wrong initial iOS calculation
  scrollToLoox("auto");

  // Then correct again after Safari/Loox/layout settles
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      scrollToLoox("smooth");
    });
  });

  // Extra iOS correction after lazy-load/widgets finish shifting
  setTimeout(function () {
    scrollToLoox("smooth");
  }, 600);

  setTimeout(function () {
    scrollToLoox("auto");
  }, 1200);
});